import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import CheckoutCompletedDialog from '../../components/coupon/CheckoutCompletedDialog';

export default () => {
  const [isOpen, setIsOpen] = useState(false);
  const { state } = useLocation();
  const { showCheckoutCompletedDialog } = state || {};
  const history = useHistory();

  useEffect(() => {
    if (showCheckoutCompletedDialog) setIsOpen(true);
  }, [showCheckoutCompletedDialog]);

  const onCancelButtonClick = () => {
    history.replace({ state: { showCheckoutCompletedDialog: false } });
    setIsOpen(false);
  };

  return (
    <CheckoutCompletedDialog isOpen={isOpen} onCancelButtonClick={onCancelButtonClick} />
  );
};
